<template>
  <modal @close="clearForm" :show.sync="$parent.modals.paymentOption">
    <h6 slot="header" class="modal-title" id="modal-title-default">Payment Option</h6>

    <form role="form" @submit.prevent="handleSubmit">
      <div class="form-row">
        <div class="col">
          <base-input
            label="First Name"
            class="mb-3"
            type="text"
            placeholder="First name"
            v-model="form.fname"
            spellcheck="false"
            required
          ></base-input>
        </div>
        <div class="col">
          <base-input
            label="Last Name"
            class="mb-3"
            type="text"
            placeholder="Last name"
            v-model="form.lname"
            spellcheck="false"
            required
          ></base-input>
        </div>
      </div>
      <base-input
        label="Address line 1"
        class="mb-3"
        type="text"
        placeholder="Street address"
        v-model="form.address"
        spellcheck="false"
        required
      ></base-input>
      <base-input
        label="Address line 2"
        class="mb-3"
        type="text"
        placeholder="Apt/suite number"
        v-model="form.apartment"
        spellcheck="false"
      ></base-input>
      <div class="form-row">
        <div class="col">
          <base-input
            label="City"
            class="mb-3"
            type="text"
            placeholder="City"
            v-model="form.city"
            spellcheck="false"
            required
          ></base-input>
        </div>
        <div class="col">
          <base-input
            label="State/Province/Region"
            class="mb-3"
            type="text"
            placeholder="State/province"
            v-model="form.state"
            spellcheck="false"
            required
          ></base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <base-input
            label="ZIP/Postal Code"
            class="mb-3"
            type="text"
            placeholder="ZIP/postal code"
            v-model="form.zip"
            spellcheck="false"
            required
          ></base-input>
        </div>
        <div class="col">
          <base-input
            label="Phone Number"
            class="mb-3"
            type="text"
            placeholder="Phone number"
            v-model="form.phone"
            spellcheck="false"
            required
          ></base-input>
        </div>
      </div>
      <div class="form-group">
        <label class="form-control-label">Credit Card</label>
        <div class="form-control" ref="stripeCard"></div>
      </div>
      <div id="card-errors" class="stripe-errors" role="alert"></div>
      <base-button :loading="loading" type="primary" nativeType="input" block size="lg">SAVE PAYMENT OPTION</base-button>
    </form>
  </modal>
</template>

<script>
import { mapState } from "vuex";
import swal from "sweetalert2";
let stripe = window.Stripe(process.env.VUE_APP_STRIPE_TOKEN),
  elements = stripe.elements(),
  card = undefined;
const apiBaseURL = process.env.VUE_APP_API_URL;

export default {
  name: "update-payment-option",
  data() {
    return {
      form: {
        zip: "",
        address: "",
        apartment: "",
        city: "",
        state: "",
        first_name: "",
        last_name: "",
        phone: ""
      },
      loading: false
    };
  },
  methods: {
    closeModal() {
      this.clearForm();
      this.$parent.modals.paymentOption = false;
    },
    showSuccessAlert() {
      swal.fire({
        type: "success",
        title: "Success!",
        text: "Your card has been updated.",
        confirmButtonColor: "#000",
        onClose: this.closeModal
      });
    },
    showErrorAlert(message) {
      swal.fire({
        type: "error",
        title: "Oh no!",
        text: message,
        confirmButtonColor: "#000"
      });
    },
    clearForm() {
      this.loading = false;
      this.form.fname = "";
      this.form.lname = "";
      this.form.address = "";
      this.form.apartment = "";
      this.form.city = "";
      this.form.state = "";
      this.form.zip = "";
      this.form.phone = "";
      card.clear();
    },
    handleSubmit() {
      let self = this;
      self.loading = true;
      stripe
        .createToken(card, { name: `${self.form.fname} ${self.form.lname}`, address_line1: self.form.address, address_line2: self.form.apartment, address_city: self.form.city, address_state: self.form.state, address_zip: self.form.zip })
        .then(function(result) {
          if (result.error) {
            self.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
            self.loading = false;
            self.showErrorAlert(
              "Card has an error. Please check card before resubmitting."
            );
            return;
          }
          self.axios
            .post(`${apiBaseURL}/api/artv1.1/user/editpaymentoption`, {
              stripetoken: result.token.id,
              name: `${self.form.fname} ${self.form.lname}`,
              address: self.form.address,
              apartment: self.form.apartment,
              city: self.form.city,
              state: self.form.state,
              zip: self.form.zip,
              phone: self.form.phone,
              email: self.user.email,
              fname: self.form.fname,
              lname: self.form.lname
            })
            .then(result => {
              if (
                result.data.error_code == 0 &&
                result.data.message == "Success"
              ) {
                if (result.data.data.message == "Success") {
                  self.$store.commit("user", {
                    card: {
                      brand: result.data.data.card.brand,
                      last_four: result.data.data.card.last_four,
                      exp_month: result.data.data.card.exp_month,
                      exp_year: result.data.data.card.exp_year
                    }
                  });
                  self.$store.commit("hasPaymentOption", true);
                  self.showSuccessAlert();
                } else {
                  self.showErrorAlert(
                    "Unable to update card. Please check all the information and try again."
                  );
                }
              } else {
                self.showErrorAlert(
                  "Error. Please try again in 10 minutes. Service not available at this time."
                );
              }
              self.loading = false;
            })
            .catch(error => {
              console.log(error);
              self.loading = false;
              self.showErrorAlert(
                "Error. Please try again in 10 minutes. Service not available at this time."
              );
            });
        });
    }
  },
  computed: {
    ...mapState(["user"])
  },
  mounted: function() {
    const style = {
      base: {
        "::placeholder": {
          color: "#8898aa"
        }
      }
    };

    if (typeof card !== "object" || card === null) {
      card = elements.create("card", { hidePostalCode: true, style: style });
    }
    card.mount(this.$refs.stripeCard);

    // Handle real-time validation errors from the card Element.
    card.addEventListener("change", function(event) {
      var displayError = document.getElementById("card-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = "";
      }
    });
  }
};
</script>

<style lang="scss">
.form-control {
  &.StripeElement {
    height: 46px;
    border: 1px solid #dee2e6;
    box-shadow: none;

    .__PrivateStripeElement {
      top: 3px;
    }
  }
  &.StripeElement--focus {
    border-color: black !important;
    box-shadow: 0 3px 9px rgba(50, 50, 9, 0), 3px 4px 8px rgba(#000, 0.1);
  }
}

.stripe-errors {
  margin-bottom: 1.4rem;
  font-size: 0.875rem;
  color: red;
  text-align: center;
}
</style>
